import React from "react";
import styles from "./ResumeTemplateProfessional.module.css";
import icon1 from "../../../../assets/images/resume-img/email-icon.png";
import icon2 from "../../../../assets/images/resume-img/phone-icon.png";
import icon3 from "../../../../assets/images/resume-img/location-icon.png";
import icon4 from "../../../../assets/images/resume-img/linkedin-icon.png";
import icon5 from "../../../../assets/images/resume-img/skype-icon.png";
import {
  dataUrl,
  getJobLocationById,
  getWorkExpText,
  toArray,
} from "../../../../helpers/common";
import {
  getEndData,
  getStartData,
} from "../../../Account/Candidate/MyProfile/ExperienceJourney";
import WebsiteLogo from "../../../../helpers/WebsiteLogo";
import { getCertificationValidity } from "..";

const ProfileImage = ({ formData }) => (
  <div className={styles.profileSection}>
    <div className={styles.profileImage}>
      <img
        src={`${dataUrl}/customers/${formData?.profile_picture}`}
        alt={formData?.name || "Profile"}
        className={styles.profileImg}
      />
    </div>
  </div>
);

const Skills = ({ skills }) => {
  const skillsArr = toArray(skills)?.slice(0, 6);
  if (!skillsArr?.length) return null;

  return (
    <div className={styles.section}>
      <h2 className={styles.sectionTitle}>
        <SectionMarkerIcon />
        SKILLS
      </h2>
      <div className={styles.skillsList}>
        {skillsArr.map((skill, index) => (
          <span className={styles.skillTag} key={index}>
            {skill}
          </span>
        ))}
      </div>
    </div>
  );
};

const Languages = ({ languages }) => {
  const languagesArr = toArray(languages)?.slice(0, 6);
  if (!languagesArr?.length) return null;

  return (
    <div className={styles.section}>
      <h2 className={styles.sectionTitle}>
        <SectionMarkerIcon />
        LANGUAGES
      </h2>
      {languagesArr.map((language, index) => (
        <div className={styles.languageItem} key={index}>
          <div className={styles.languageName}>{language}</div>
          <div className={styles.languageLevel}>
            Professional Working Proficiency
          </div>
        </div>
      ))}
    </div>
  );
};

const Certificates = ({ certifications }) => {
  if (!certifications?.length) return null;



  return (
    <div className={styles.section}>
      <h2 className={styles.sectionTitle}>
        <SectionMarkerIcon />
        CERTIFICATES
      </h2>
      {certifications?.map((cert, index) => (
        <div className={styles.certificateItem} key={index}>
          <a
            href={cert?.additional_fields?.url || "#"}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.certificateName}
          >
            {cert?.additional_fields?.title || cert?.title || cert?.name}
            <i className={`mdi mdi-open-in-new fs-15 ms-2 ${styles.certificateIcon}`}></i>
          </a>
          <div className={styles.certificateOrg}>
            {cert?.additional_fields?.organization ||
              cert?.organization ||
              "Organization"}
          </div>

          <div className={styles.certificateOrg}>
            {getCertificationValidity(cert)}
          </div>
        </div>
      ))}
    </div>
  );
};

const Awards = ({ awards }) => {
  if (!awards?.length) return null;

  return (
    <div className={styles.section}>
      <h2 className={styles.sectionTitle}>
        <SectionMarkerIcon />
        HONOR AWARDS
      </h2>
      {awards.map((award, index) => (
        <div className={styles.awardItem} key={index}>
          <div className={styles.awardName}>
            {typeof award === "string" ? award : award?.name || award?.title}
          </div>
          <div className={styles.awardOrg}>
            {award?.organization || "Organization"}
          </div>
        </div>
      ))}
    </div>
  );
};

const Interests = ({ interests }) => {
  const interestsArr = toArray(interests)?.slice(0, 4);
  if (!interestsArr?.length) return null;

  return (
    <div className={styles.section}>
      <h2 className={styles.sectionTitle}>
        <SectionMarkerIcon />
        INTERESTS
      </h2>
      <div className={styles.interestsList}>
        {interestsArr.map((interest, index) => (
          <div className={styles.interestItem} key={index}>
            <span className={styles.interestIcon}></span>
            <span>{interest}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

const Header = ({ formData, jobLocations }) => (
  <div className={styles.header}>
    <h1 className={styles.name}>{formData?.name || "Your Name"}</h1>
    <h2 className={styles.jobTitle}>{formData?.designation || "Your Title"}</h2>
    {formData?.details && <p className={styles.summary}>{formData.details}</p>}

    <div className={styles.contactInfo}>
      <div className={styles.contactColumn}>
        {formData?.email && (
          <div className={styles.contactItem}>
            <img src={icon1} alt="email" className={styles.contactIcon} />
            <span>{formData.email}</span>
          </div>
        )}
        {formData?.location && (
          <div className={styles.contactItem}>
            <img src={icon3} alt="location" className={styles.contactIcon} />
            <span>
              {getJobLocationById(formData.location, jobLocations)}, India
            </span>
          </div>
        )}
        {formData?.skype && (
          <div className={styles.contactItem}>
            <img src={icon5} alt="skype" className={styles.contactIcon} />
            <span>{formData.skype}</span>
          </div>
        )}
      </div>

      <div className={styles.contactColumn}>
        {formData?.mobile_number && (
          <div className={styles.contactItem}>
            <img src={icon2} alt="phone" className={styles.contactIcon} />
            <span>{formData.mobile_number}</span>
          </div>
        )}
        {formData?.linkedin && (
          <div className={styles.contactItem}>
            <img src={icon4} alt="linkedin" className={styles.contactIcon} />
            <span>{formData.linkedin}</span>
          </div>
        )}
      </div>
    </div>
  </div>
);

const Experience = ({ experience, resumeBuilder }) => {
  if (!experience?.length) return null;

  const totalExperience = resumeBuilder?.total_work_experience
    ? `(${getWorkExpText(resumeBuilder?.total_work_experience)?.trim()})`
    : "";

  return (
    <div className={styles.mainSection}>
      <h2 className={styles.mainSectionTitle}>
        <SectionMarkerIcon />
        WORK EXPERIENCE {totalExperience}
      </h2>

      {experience.map((job, idx) => (
        <div className={styles.experienceItem} key={idx}>
          <div className={styles.experienceHeader}>
            <div>
              <h3 className={styles.jobPosition}>
                {job?.additional_fields?.position || job?.position}
              </h3>
              <h4 className={styles.company}>
                {job?.additional_fields?.company_name || job?.company_name}
              </h4>
            </div>
          </div>
          <div className={styles.dateLocation}>
            <div className={styles.date}>
              {getStartData(job?.additional_fields)} -{" "}
              {getEndData(job?.additional_fields)}
            </div>
            <div className={styles.location}>
              {job?.additional_fields?.location || job?.location}
            </div>
          </div>
          {job?.additional_fields?.details && (
            <ul className={styles.experienceList}>
              {toArray(job.additional_fields.details, "\n").map((detail, i) => (
                <li key={i}>{detail}</li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
};

const Education = ({ educations }) => {
  if (!educations?.length) return null;

  return (
    <div className={styles.mainSection}>
      <h2 className={styles.mainSectionTitle}>
        <SectionMarkerIcon />
        EDUCATION
      </h2>
      {educations.map((education, idx) => (
        <div className={styles.educationItem} key={idx}>
          <h3 className={styles.degree}>
            {education?.additional_fields?.title || education?.title}
          </h3>
          <h4 className={styles.school}>
            {education?.additional_fields?.university_college ||
              education?.university_college ||
              education?.school}
          </h4>
          <div className={styles.educationDate}>
            {getStartData(education?.additional_fields)} -{" "}
            {getEndData(education?.additional_fields)}
          </div>
        </div>
      ))}
    </div>
  );
};

const SectionMarkerIcon = () => (
  <span className={styles.icon}>
    <span className={styles.sectionMarkerIcon}>
      <span className={styles.sectionMarkerIconOuter}></span>
      <span className={styles.sectionMarkerIconInner}></span>
    </span>
  </span>
);

const ResumeTemplateProfessional = ({
  formData,
  jobLocations,
  experiences,
  certifications,
  qualifications,
}) => {
  // Use the same data structure as ResumeTemplateModern.js
  const languages = formData?.languages_known;
  const awards = formData?.awards;
  const interests = formData?.hobbies; // Use hobbies instead of interests

  return (
    <div className={styles.resume}>
      <div className={styles.container}>
        {/* Left Sidebar */}
        <div className={styles.sidebar}>
          <ProfileImage formData={formData} />
          <Skills skills={formData?.skills} />
          <Languages languages={languages} />
          <Certificates certifications={certifications} />
          <Awards awards={awards} />
          <Interests interests={interests} />
        </div>

        {/* Main Content */}
        <div className={styles.mainContent}>
          <Header formData={formData} jobLocations={jobLocations} />
          <Experience experience={experiences} resumeBuilder={formData} />
          <Education educations={qualifications} />

          {/* Resume Footer */}
          <div className="resume-footer">
            Generated by{" "}
            <a href="https://jobseekerspage.com/" style={{ color: "#888" }}>
              <WebsiteLogo />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResumeTemplateProfessional;
